import React, { useRef } from 'react';
import { motion, useInView, useReducedMotion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './Button';
const FINAL_VIDEO_ID = 'Pc9dQXIu13k';
const posterImage = 'https://i.ytimg.com/vi/Pc9dQXIu13k/maxresdefault.jpg';
export function FinalCta() {
  const {
    t
  } = useLanguage();
  const sectionRef = useRef<HTMLElement>(null);
  const isVisible = useInView(sectionRef, {
    margin: '200px 0px 200px 0px'
  });
  const reduceMotion = useReducedMotion();
  return <section ref={sectionRef} className="relative flex min-h-[78svh] items-center overflow-hidden bg-ink px-5 py-28 text-center text-ivory md:px-8 md:py-36 lg:px-12" data-id="element-41" data-mp="1edinzen8alv2">
      <div className="absolute inset-0 overflow-hidden" aria-hidden="true" data-id="element-42" data-mp="1o3len86vnnq8">
        <img src={posterImage} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover" data-id="element-43" data-mp="223d1lyfdgegd" />
        {isVisible && !reduceMotion ? <iframe src={`https://www.youtube-nocookie.com/embed/${FINAL_VIDEO_ID}?autoplay=1&mute=1&loop=1&playlist=${FINAL_VIDEO_ID}&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1&iv_load_policy=3&disablekb=1&fs=0`} title={t.finalCta.videoTitle} allow="autoplay; encrypted-media" className="pointer-events-none absolute left-1/2 top-1/2 h-[177.78vw] min-h-full w-screen min-w-[56.25vh] -translate-x-1/2 -translate-y-1/2 border-0" data-id="element-44" data-mp="1x64j1wqba8el" /> : null}
      </div>
      <div className="absolute inset-0 bg-ink/65" data-id="element-45" data-mp="162m9gnhb8oqm" />

      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="relative z-10 mx-auto max-w-2xl" data-id="element-46" data-mp="1b2i6g2rlbfwo">
        <h2 className="font-display text-4xl leading-[1.02] md:text-6xl" data-id="element-47" data-mp="1kvfq4c8bjawv">
          {t.finalCta.lineOne}<br data-id="element-48" data-mp="1puagq0cj23rj" /><span className="italic text-gold-soft" data-id="element-49" data-mp="1pqcyri1ori98">{t.finalCta.lineTwo}</span>
        </h2>
        <div className="mt-10 flex justify-center" data-id="element-50" data-mp="1tuavjm3jggz4">
          <Button href="#quote" data-id="element-51" data-mp="3qu5lvwnyz3jt">{t.navigation.cta}</Button>
        </div>
      </motion.div>
    </section>;
}